import { AppActions, AppActionsTypes } from '../actions';
import { AppState } from '../../typings/app-state';
import { COUNTRY_CODE } from '@cemex-core/cmx-api';

const initialState: AppState = {
  mobile: false,
  auth: undefined,
  direction: 'ltr',
  language: undefined,
  loader: true,
  authenticated: false,
  initialized: false,
  languages: [],
  alerts: {},
  legalEntity: undefined,
  version: window['CX_VERSION'] !== '2' ? 3 : 2,
  parameters: [],
  copyright: [],
};

export function appReducer(state = initialState, action: AppActions): AppState {
  switch (action.type) {
    case AppActionsTypes.SET_MOBILE: {
      if (state.mobile === action.payload) {
        return state;
      }
      return {
        ...state,
        mobile: action.payload,
      };
    }
    case AppActionsTypes.AUTH_RESTORE: {
      return {
        ...state,
        auth: action.payload,
        authenticated: true,
      };
    }
    case AppActionsTypes.SET_LOADER: {
      if (state.loader === action.payload) {
        return state;
      }
      return {
        ...state,
        loader: action.payload,
      };
    }
    case AppActionsTypes.LOGIN_START: {
      return {
        ...state,
        loader: true,
      };
    }
    case AppActionsTypes.LOGIN_ERROR: {
      return {
        ...state,
        loader: false,
      };
    }
    case AppActionsTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        auth: action.payload,
        authenticated: true,
      };
    }
    case AppActionsTypes.SET_LANGUAGE: {
      return {
        ...state,
        language: action.payload,
      };
    }
    case AppActionsTypes.SET_LANGUAGES: {
      return {
        ...state,
        languages: action.payload,
      };
    }
    case AppActionsTypes.UPDATE_ALERTS: {
      return {
        ...state,
        alerts: { ...action.payload },
      };
    }
    case AppActionsTypes.SET_LEGAL_ENTITY: {
      return {
        ...state,
        legalEntity: {
          ...action.payload,
          countryCode: action.payload.countryCode.trim() as COUNTRY_CODE,
        },
      };
    }
    case AppActionsTypes.INITIALIZE: {
      return {
        ...state,
        initialized: true,
      };
    }
    case AppActionsTypes.SET_DIRECTION: {
      return {
        ...state,
        direction: action.payload,
      };
    }
    case AppActionsTypes.ADD_ALERT: {
      const updatedAlerts = state.alerts[action.target]
        ? [action.alert, ...state.alerts[action.target]]
        : [action.alert];
      return {
        ...state,
        alerts: {
          ...state.alerts,
          [action.target]: updatedAlerts,
        },
      };
    }
    case AppActionsTypes.REMOVE_ALERT: {
      const updatedAlerts = state.alerts[action.target] ? [...state.alerts[action.target]] : [];
      // Nothing to remove, already empty set
      if (updatedAlerts.length === 0) {
        return state;
      }
      const indexToDelete = updatedAlerts.findIndex((alert) => alert.id === action.id);
      updatedAlerts.splice(indexToDelete, 1);
      return {
        ...state,
        alerts: {
          ...state.alerts,
          [action.target]: updatedAlerts,
        },
      };
    }
    case AppActionsTypes.SET_VERSION: {
      return {
        ...state,
        version: action.payload,
      };
    }
    case AppActionsTypes.SET_PARAMETERS: {
      return {
        ...state,
        parameters: action.payload,
      };
    }
    case AppActionsTypes.SET_COPYRIGHT: {
      return {
        ...state,
        copyright: action.payload,
      };
    }
    default:
      return state;
  }
}
